module.exports = __webpack_public_path__ + "img/folder.24a5a395.svg";